import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MimaCheckout } from '../../pages';
import { InvoiceController } from '../../controllers';
import { invoiceStore } from '../../stores';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import moment from 'moment';

const MimaCheckoutContainer = () => {
	const [timeLeft, setTimeLeft] = useState('');
	const [validatePay, setValidatePay] = useState(false);
	const [chooseBank, setChooseBank] = useState('');
	const [paid, setPaid] = useState(false);
	const [loading, setLoading] = useState(true);
	const [loading2, setLoading2] = useState(true);
	const [intervalTime, setIntervalTime] = useState(30000);

	const [searchParams] = useSearchParams();
	const id = searchParams.get('invoiceId');

	const timedOut = timeLeft === 'Time is up!' ? true : false;

	const countdown = (minutes, seconds) => {
		let endTime, hours, mins, msLeft, time;

		function twoDigits(n) {
			return n <= 9 ? '0' + n : n;
		}

		function updateTimer() {
			msLeft = endTime - +new Date();
			if (msLeft < 1000) {
				setTimeLeft('Time is up!');
			} else {
				time = new Date(msLeft);
				hours = time.getUTCHours();
				mins = time.getUTCMinutes();
				setTimeLeft(
					(hours ? hours + ':' + twoDigits(mins) : mins) +
						':' +
						twoDigits(time.getUTCSeconds())
				);
				setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
			}
		}

		endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
		updateTimer();
	};

	const getpaymentDetails = async () => {
		setLoading(true);
		const { status } = await InvoiceController.invoicePaymentCheckout(id);
		if (status === constant.Success) {
			setLoading(false);
			setChooseBank(invoiceStore.checkoutData.accounts[0].bank);
			const expiryDate = moment(
				invoiceStore.checkoutData.expiryDate,
				'YYYY-MM-DDThh:mm:ss:sssZ'
			);
			const currentDate = moment(new Date(), 'YYYY-MM-DDThh:mm:ss:sssZ');
			const timeDiff = expiryDate.diff(currentDate, 'seconds');
			const mins = Math.floor(timeDiff / 60);
			const secs = timeDiff % 60;

			countdown(mins, secs);
		}
	};

	useEffect(() => {
		getpaymentDetails();
	}, []);

	useEffect(() => {
		let interval = setInterval(async () => {
			const { status, data, errorMessage } =
				await InvoiceController.invoicePaymentConfirm(id);
			if (status === constant.Success) {
				if (data.msg === 'Payment Confirmed') {
					clearInterval(interval);
					setLoading(false);
					setPaid(true);
				}
			} else {
				MimaToastUtil.error({ message: errorMessage });
			}
		}, intervalTime);

		return () => {
			clearInterval(interval);
		};
	}, []);

	const validatePaymentClick = async () => {
		setLoading2(true);
		const { status, data } = await InvoiceController.invoicePaymentConfirm(id);
		if (status === constant.Success) {
			if (data.msg === 'Payment Confirmed') {
				// clearInterval(interval);
				setLoading2(false);
				setPaid(true);
			}
		} else {
			// setLoading(false);
			// MimaToastUtil.error({ message: errorMessage });
		}
		setIntervalTime(10000);
		setValidatePay(true);
	};

	return (
		<MimaCheckout
			timeLeft={timeLeft}
			timedOut={timedOut}
			validatePay={validatePay}
			validatePaymentClick={validatePaymentClick}
			chooseBank={chooseBank}
			setChooseBank={setChooseBank}
			loading={loading}
			paid={paid}
			loading2={loading2}
		/>
	);
};

export default MimaCheckoutContainer;
